"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Phone = void 0;
var features_1 = require("../features");
Object.defineProperty(exports, "Phone", { enumerable: true, get: function () { return features_1.Phone; } });
//# sourceMappingURL=index.js.map